module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"part_select.card.part_sku":"SKU : ","part_select.card.part_name":"ชื่ออะไหล่ : ","part_select.card.part_name_en":"ชื่ออะไหล่ (EN) : ","part_select.card.part_name_type":"ประเภท : ","part_select.card.part_price":"ราคาขาย/หน่วย : ","part_select.card.select":"เลือกอะไหล่"}}')
  delete Component.options._Ctor
}
